/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload200,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload400,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload401,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload500,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationRequest,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadPathParams,
} from "../../types/individualPaymentInvoicesController/PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload.ts";

export const postApiV1IndividualpaymentParcelsParcelidInvoiceUploadPathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentParcelsParcelidInvoiceUpload200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload200>;

/**
 * @description Arquivo inválido ou NFe em processamento
 */
export const postApiV1IndividualpaymentParcelsParcelidInvoiceUpload400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentParcelsParcelidInvoiceUpload401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentParcelsParcelidInvoiceUpload500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload500>;

export const postApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationRequestSchema =
  z.object({
    file: z.optional(z.instanceof(File)),
  }) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationRequest>;

export const postApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationResponseSchema =
  z.lazy(
    () => postApiV1IndividualpaymentParcelsParcelidInvoiceUpload200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationResponse>;
